import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from './Components/Main/Main';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Main></Main>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
